import { useState, useEffect } from 'react';
import { ConnectionStatus } from '../types';
import { localComms } from '../../localComms';

/**
 * Desktop-only hook that subscribes to localComms device status
 * Returns the current ConnectionStatus or null if unavailable
 */
export function useDesktopDeviceStatus(): ConnectionStatus | null {
  const [status, setStatus] = useState<ConnectionStatus | null>(
    localComms.getLocalDeviceStatus?.() ?? null,
  );

  useEffect(() => {
    const cleanup = localComms.subscribeToDeviceStatus
      ? localComms.subscribeToDeviceStatus(setStatus)
      : () => {
          /* noop */
        };

    return cleanup;
  }, []);

  return status;
}
